import React from 'react';
import { classes, st } from './WeeklyDatePicker.st.css';
import {
  WeeklyDatePicker as WeeklyDatePickerTPA,
  DatePickerFirstDayOfWeek,
  DatePickerLocale,
  WeekDatesRange,
} from 'wix-ui-tpa/cssVars';
import {
  isSameDay,
  getLocalDateTimeEndOfDay,
  getLocalDateTimeStartOfDay,
} from '@wix/bookings-catalog-calendar-viewer-utils/dateAndTime';
import { useDailyAgendaActions } from '../../../components/DailyAgenda/hooks/useDailyAgendaActions';
import { useWidgetViewModel } from '../../../components/DailyAgenda/hooks/useWidgetViewModel';
import { WeeklyDatepickerDataHooks } from './const';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { WidgetComponents, WidgetElements } from '../../../utils/bi/consts';
import { useDatePicker } from '../../../components/DailyAgenda/hooks/useDatePicker';

export interface WeeklyDatePickerProps {}

export const WeeklyDatePicker: React.FC<WeeklyDatePickerProps> = () => {
  const { onWeekChange, onDaySelected, onElementClicked } =
    useDailyAgendaActions();
  const { datePickerViewModel } = useWidgetViewModel();
  const { isMobile } = useEnvironment();
  const {
    availableDates,
    firstDayOfTheWeek = 0,
    locale,
  } = datePickerViewModel || {};
  const { currentDate, setCurrentDate } = useDatePicker();

  if (!currentDate) {
    return null;
  }

  const filterDates = (date: Date) => {
    return (
      isSameDay(new Date(date), currentDate) ||
      !!availableDates?.find((availableDate) =>
        isSameDay(new Date(date), new Date(availableDate)),
      )
    );
  };
  const onDisplayedWeekChange = (week: WeekDatesRange) => {
    onWeekChange({
      from: getLocalDateTimeStartOfDay(week.startOfWeek),
      to: getLocalDateTimeEndOfDay(week.endOfWeek),
    });
    onElementClicked(WidgetComponents.DATE_PICKER, WidgetElements.WEEK_ARROW);
  };

  return (
    <div
      className={st(classes.root, { isMobile })}
      data-hook={WeeklyDatepickerDataHooks.Main}
    >
      <WeeklyDatePickerTPA
        excludePastDates={true}
        locale={locale as DatePickerLocale}
        data-hook={WeeklyDatepickerDataHooks.WeeklyDatepicker}
        value={currentDate}
        onDisplayedWeekChange={onDisplayedWeekChange}
        firstDayOfWeek={firstDayOfTheWeek as DatePickerFirstDayOfWeek}
        filterDate={filterDates}
        removeOuterPadding
        onChange={(day: Date) => {
          setCurrentDate(day);
          onDaySelected(day.toISOString());
          onElementClicked(
            WidgetComponents.DATE_PICKER,
            WidgetElements.DATE_IN_MONTH,
            {
              date: day.toISOString(),
            },
          );
        }}
        groupWeekdaysAndDates
        arrowLocation={isMobile ? 'caption' : 'dates'}
      />
    </div>
  );
};
